import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'
import { IContextMessage } from '../../../types/contextMessage.types'

export function contextMessageApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/context-message'
  const methods = {
    getContextMessage() {
      return api.get<IContextMessage>(baseUrl)
    },
    setContextMessage(conceptIds: string[]) {
      return api.put<IContextMessage>(baseUrl, { concept_ids: conceptIds })
    },
    updateLanguage(language: string, text: string) {
      return api.put<IContextMessage>(`${baseUrl}/language/${language}`, { text })
    },
    clearLanguage(language: string) {
      return api.delete<IContextMessage>(`${baseUrl}/language/${language}`)
    }
  }
  return createOptimizedAPI(methods)
}
